import { render, staticRenderFns } from "./WithdrawalList.vue?vue&type=template&id=68281a54&scoped=true"
import script from "./WithdrawalList.vue?vue&type=script&lang=js"
export * from "./WithdrawalList.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalList.vue?vue&type=style&index=0&id=68281a54&prod&lang=scss&scoped=true"
import style1 from "./WithdrawalList.vue?vue&type=style&index=1&id=68281a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68281a54",
  null
  
)

export default component.exports